(() => {
  const productIds = new Set([15418553303284,15418553762036]);
  const orgSelector = '[name="attributes[Hawk Organization]"]';
  const cartHasHawk = cart => cart.items.some(item => productIds.has(item.product_id));
  const updateNotification = hasHawk => {
    const form = document.getElementById('cart-notification-form');
    if (!form) return;
    form.querySelector('[name="checkout"]')?.toggleAttribute('disabled',hasHawk);
    form.hidden = hasHawk;
  };
  const refresh = async () => {
    try {
      const response = await fetch(window.routes.cart_url + '.js',{headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      const hasHawk = cartHasHawk(cart);
      updateNotification(hasHawk);
      const guard = document.querySelector(orgSelector);
      if (document.getElementById('cart') && Boolean(guard) !== hasHawk) {
        window.location.reload();
      }
    } catch {}
  };
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.id === 'cart-notification-form' && form.hidden) {
      event.preventDefault();
      window.location.assign(window.routes.cart_url);
      return;
    }
    if (form.id !== 'cart') return;
    const field = document.querySelector(orgSelector);
    if (!field || event.submitter?.name !== 'checkout') return;
    field.value = field.value.trim();
    if (!field.value) {
      event.preventDefault();
      field.setCustomValidity(field.dataset.requiredMessage);
      field.reportValidity();
      field.focus();
    }
  },true);
  document.addEventListener('input',event => {
    if (event.target.matches(orgSelector)) event.target.setCustomValidity('');
  });
  document.addEventListener('DOMContentLoaded',() => {
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate,refresh);
    refresh();
  });
})();
